import { Box, Button, Flex, Heading, Stack, Text } from '@chakra-ui/react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import TodoIcon from '../TodoIcon';
import { Todo } from '../types';
import { todoKindMeta } from './lib';

interface Props {
  todo: Todo;
  onClose: () => void;
}

function TodoDocument({ todo, onClose }: Props) {
  const { description } = todoKindMeta(todo.target.__typename, todo.kind);

  return (
    <Stack spacing={10}>
      <Text>{description}</Text>
      <Flex align="center">
        <TodoIcon target={todo.target} kind={todo.kind} mr={3} />
        <Flex direction="column" justify="center">
          <Heading as="h6" size="xs" noOfLines={1}>
            {todo.target.name}
          </Heading>
          <Text>Client: {todo.target.client.fullName}</Text>
        </Flex>
      </Flex>
      <Text>
        Please, complete this task on or before{' '}
        <Text as="span" color="red.400">
          {moment(todo.deadline).format('ll')}
        </Text>
        .
      </Text>
      <Box textAlign="center">
        <Button
          colorScheme="purple"
          as={Link}
          to={`clients/${todo.target.client.id}/documents/${todo.target.id}/settings`}
          onClick={onClose}
        >
          Go to document&apos;s settings
        </Button>
      </Box>
    </Stack>
  );
}

export default TodoDocument;
